import { motion } from "framer-motion";

interface CardValue { rank: string; suit: string; red: boolean }

const face = "absolute inset-0 rounded-2xl border-[4px] border-ink";

export function PlayingCard({ value, fast }: { value: CardValue; fast: boolean }) {
  const color = value.red ? "text-[#E11D48]" : "text-ink";
  return (
    <div className="h-40 w-28 sm:h-44 sm:w-32" style={{ perspective: 900 }} data-testid="playing-card-anim">
      <motion.div className="relative h-full w-full" style={{ transformStyle: "preserve-3d" }}
        initial={{ rotateY: fast ? 0 : 900, scale: fast ? 1 : 0.6 }} animate={{ rotateY: 0, scale: 1 }}
        transition={{ duration: fast ? 0 : 0.85, ease: [0.2, 0.8, 0.3, 1] }}>
        <div className={`${face} flex flex-col justify-between bg-white p-2 pop-shadow ${color}`} style={{ backfaceVisibility: "hidden" }}>
          <span className="font-display text-2xl font-bold leading-none">{value.rank}<br />{value.suit}</span>
          <span className="self-center text-5xl">{value.suit}</span>
          <span className="rotate-180 font-display text-2xl font-bold leading-none">{value.rank}<br />{value.suit}</span>
        </div>
        <div className={`${face} halftone-light flex items-center justify-center bg-pop-purple`} style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}>
          <span className="comic-title-sm text-4xl text-pop-yellow">D</span>
        </div>
      </motion.div>
    </div>
  );
}
